import React from "react";

// Web3 NFT 風格像素頭像
const avatars = [
  // #0 — 綠色機器人
  (s) => (
    <svg viewBox="0 0 24 24" width={s} height={s}>
      <rect width="24" height="24" rx="12" fill="#0a0a0a"/>
      <rect x="6" y="4" width="12" height="12" rx="2" fill="#00d46a"/>
      <rect x="8" y="7" width="3" height="3" rx="1" fill="#0a0a0a"/>
      <rect x="13" y="7" width="3" height="3" rx="1" fill="#0a0a0a"/>
      <rect x="9" y="12" width="6" height="2" rx="1" fill="#0a0a0a"/>
      <rect x="4" y="8" width="2" height="4" rx="1" fill="#00d46a"/>
      <rect x="18" y="8" width="2" height="4" rx="1" fill="#00d46a"/>
      <rect x="8" y="18" width="3" height="3" rx="1" fill="#00d46a"/>
      <rect x="13" y="18" width="3" height="3" rx="1" fill="#00d46a"/>
    </svg>
  ),
  // #1 — 紫色外星人
  (s) => (
    <svg viewBox="0 0 24 24" width={s} height={s}>
      <rect width="24" height="24" rx="12" fill="#1a0a2e"/>
      <ellipse cx="12" cy="12" rx="7" ry="8" fill="#8b5cf6"/>
      <ellipse cx="9" cy="10" rx="2.5" ry="3" fill="#1a0a2e"/>
      <ellipse cx="15" cy="10" rx="2.5" ry="3" fill="#1a0a2e"/>
      <ellipse cx="9" cy="10" rx="1" ry="1.5" fill="#00ff88"/>
      <ellipse cx="15" cy="10" rx="1" ry="1.5" fill="#00ff88"/>
      <ellipse cx="12" cy="15" rx="2" ry="1" fill="#1a0a2e"/>
    </svg>
  ),
  // #2 — 橘色狐狸
  (s) => (
    <svg viewBox="0 0 24 24" width={s} height={s}>
      <rect width="24" height="24" rx="12" fill="#1a1008"/>
      <polygon points="12,3 4,12 6,20 18,20 20,12" fill="#f59e0b"/>
      <polygon points="4,12 8,6 10,12" fill="#d97706"/>
      <polygon points="20,12 16,6 14,12" fill="#d97706"/>
      <circle cx="9" cy="12" r="1.5" fill="#1a1008"/>
      <circle cx="15" cy="12" r="1.5" fill="#1a1008"/>
      <polygon points="11,15 12,17 13,15" fill="#1a1008"/>
    </svg>
  ),
  // #3 — 青色幽靈
  (s) => (
    <svg viewBox="0 0 24 24" width={s} height={s}>
      <rect width="24" height="24" rx="12" fill="#0a1a1a"/>
      <path d="M7 21V10a5 5 0 0 1 10 0v11l-2-2-3 2-3-2-2 2z" fill="#06b6d4"/>
      <circle cx="10" cy="11" r="1.5" fill="#0a1a1a"/>
      <circle cx="14" cy="11" r="1.5" fill="#0a1a1a"/>
      <circle cx="10" cy="10.5" r="0.5" fill="white"/>
      <circle cx="14" cy="10.5" r="0.5" fill="white"/>
    </svg>
  ),
  // #4 — 粉色貓
  (s) => (
    <svg viewBox="0 0 24 24" width={s} height={s}>
      <rect width="24" height="24" rx="12" fill="#1a0a14"/>
      <polygon points="6,8 8,3 11,8" fill="#ec4899"/>
      <polygon points="18,8 16,3 13,8" fill="#ec4899"/>
      <ellipse cx="12" cy="14" rx="7" ry="6" fill="#ec4899"/>
      <ellipse cx="9" cy="12" rx="1.5" ry="2" fill="#1a0a14"/>
      <ellipse cx="15" cy="12" rx="1.5" ry="2" fill="#1a0a14"/>
      <ellipse cx="9" cy="12.5" rx="0.5" ry="1" fill="#00ff88"/>
      <ellipse cx="15" cy="12.5" rx="0.5" ry="1" fill="#00ff88"/>
      <line x1="5" y1="13" x2="2" y2="12" stroke="#ec4899" strokeWidth="0.8"/>
      <line x1="5" y1="15" x2="2" y2="15" stroke="#ec4899" strokeWidth="0.8"/>
      <line x1="19" y1="13" x2="22" y2="12" stroke="#ec4899" strokeWidth="0.8"/>
      <line x1="19" y1="15" x2="22" y2="15" stroke="#ec4899" strokeWidth="0.8"/>
      <polygon points="11,15 12,16.5 13,15" fill="#1a0a14"/>
    </svg>
  ),
];

const NftAvatar = ({ id = 0, size = 36 }) => {
  const idx = ((id % avatars.length) + avatars.length) % avatars.length;
  return (
    <span className="nft-avatar" style={{ width: size, height: size, display: "inline-flex", flexShrink: 0 }}>
      {avatars[idx](size)}
    </span>
  );
};

export default NftAvatar;
